<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editForm" ref="editFormRef" label-width="90px">
          <el-form-item label="归属机构" class="addAdminForm">
            <el-select v-model="editForm.jigouid" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDian"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" class="addAdminForm">
            <el-date-picker v-model="editForm.riqi" type="date" placeholder="日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="类别" class="addAdminForm">
            <el-select v-model="editForm.leibie" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDianChanPingLeiBie"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" class="addAdminForm">
            <el-input v-model="editForm.name" placeholder="请输入名称" disabled></el-input>
          </el-form-item>
          <el-form-item label="规格/型号" class="addAdminForm">
            <el-input v-model="editForm.guige" placeholder="请输入规格/型号" disabled></el-input>
          </el-form-item>
          <el-form-item label="采购单价" class="addAdminForm">
            <el-input v-model="editForm.stockindanjia" placeholder="请输入采购单价" @input="processAmount()"></el-input>
          </el-form-item>
          <el-form-item label="代理商单价" class="addAdminForm">
            <el-input v-model="editForm.dlsdanjia" placeholder="请输入代理商单价" @input="processAmount()"></el-input>
          </el-form-item>
          <el-form-item label="建议零售单价" class="addAdminForm">
            <el-input v-model="editForm.saledanjia" placeholder="请输入建议零售单价"></el-input>
          </el-form-item>
          <el-form-item label="采购数量" class="addAdminForm">
            <el-input v-model="editForm.num" placeholder="请输入采购数量" @input="processAmount()"></el-input>
          </el-form-item>
          <el-form-item label="采购金额" class="addAdminForm">
            <el-input v-model="editForm.stockinamount" placeholder="请输入采购金额" disabled></el-input>
          </el-form-item>
          <el-form-item label="代理商金额" class="addAdminForm">
            <el-input v-model="editForm.dlsamount" placeholder="请输入代理商金额" disabled></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editForm: {
        id: '0',
        jigouid: '0',
        jigouname: '',
        riqi: '',
        leibie: '',
        name: '',
        guige: '',
        stockindanjia: '0',
        dlsdanjia: '0',
        saledanjia: '0',
        num: '0',
        stockinamount: '0',
        dlsamount: '0'
      },
      RuiShiLiYanKeMenDian:[],
      RuiShiLiYanKeMenDianChanPingLeiBie:[],
    }
  },
  mounted () {
    this.RuiShiLiYanKeMenDian = Vue.prototype.FunGetRuiShiLiYanKeMenDian()
    this.RuiShiLiYanKeMenDianChanPingLeiBie = Vue.prototype.FunGetRuiShiLiYanKeMenDianChanPingLeiBie()
  },
  methods: {
    LoadData (row) {
      this.editForm.id = row.Id
      this.editForm.jigouid = row.Jigouid.toString()
      this.editForm.jigouname = row.Jigouname
      this.editForm.riqi = row.Riqi
      this.editForm.leibie = row.Leibie
      this.editForm.name = row.Name
      this.editForm.guige = row.Guige
      this.editForm.stockindanjia = row.Stockindanjia
      this.editForm.dlsdanjia = row.Dlsdanjia
      this.editForm.saledanjia = row.Saledanjia
      this.editForm.num = row.Num
      this.editForm.stockinamount = row.Stockinamount
      this.editForm.dlsamount = row.Dlsamount
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditMenDianPurchaseSalesJinXiao()
    },
    processAmount (){
      var buf1 = Number(this.editForm.stockindanjia) * Number(this.editForm.num)
      var buf2 = Number(this.editForm.dlsdanjia) * Number(this.editForm.num)
      this.editForm.stockinamount = this.pnum(buf1)
      this.editForm.dlsamount = this.pnum(buf2)
    },
    pnum (num) {
      return Number(Number(num).toFixed(2))
    },
    apiEditMenDianPurchaseSalesJinXiao: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        jigouid: that.editForm.jigouid,
        riqi: that.editForm.riqi,
        leibie: that.editForm.leibie,
        name: that.editForm.name,
        guige: that.editForm.guige,
        stockindanjia: that.editForm.stockindanjia,
        dlsdanjia: that.editForm.dlsdanjia,
        saledanjia: that.editForm.saledanjia,
        num: that.editForm.num,
        stockinamount: that.editForm.stockinamount,
        dlsamount: that.editForm.dlsamount
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditMenDianPurchaseSalesJinXiao, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
